import { Injectable, inject } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';

import {
  ConfirmationDialogComponent,
  ConfirmationDialogData,
} from '../widgets/confirmation-dialog/confirmation-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationService {
  private readonly dialog = inject(DialogService);

  async confirm(data: ConfirmationDialogData) {
    return await ConfirmationDialogComponent.open(this.dialog, data);
  }
}
